import { render, staticRenderFns } from "./editAgreement.vue?vue&type=template&id=60bd80b2&scoped=true&"
import script from "./editAgreement.vue?vue&type=script&lang=js&"
export * from "./editAgreement.vue?vue&type=script&lang=js&"
import style0 from "./editAgreement.vue?vue&type=style&index=0&id=60bd80b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bd80b2",
  null
  
)

export default component.exports